import styled from 'styled-components';

interface NotesButtonWrapperProps {
  isActive?: boolean;
}

export const NotesButtonWrapper = styled.button<NotesButtonWrapperProps>`
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.iconAccentHover};
      stroke: ${({ theme }) => theme.colors.iconAccentHover};
    };
  }
  svg {
    fill: ${({ theme, isActive }) => isActive ? theme.colors.iconAccentActive : theme.colors.iconPrimary};
    stroke: ${({ theme, isActive }) => isActive ? theme.colors.iconAccentActive : theme.colors.iconPrimary};
  }
`;
